import config from "../configure/PidConfigure.json";

export const getComponentAccess = (pid) => {
  // exact match with PID from Redux/session
  return config.projects[pid] || config.default;
};

export const canAccess = (pid, componentName) => {
  const access = getComponentAccess(pid);
  return access?.[componentName] ?? false;
};